import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=e978e648&scoped=true&"
import script from "./ResultModal.vue?vue&type=script&lang=js&"
export * from "./ResultModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=e978e648&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e978e648",
  null
  
)

export default component.exports